import React from 'react';
import PropTypes from 'prop-types';

const Leadership = () => {
  return (
    <div className='ml-20'>
      <p className='h4 w3'>Leadership</p>
    </div>
  );
};

Leadership.propTypes = {

};

export default Leadership;
